import { z } from "zod";
const selectedSecuritySchemeUidSchema = z.union([
  z.string().brand(),
  z.string().brand().array()
]).array().default([]);
export {
  selectedSecuritySchemeUidSchema
};
//# sourceMappingURL=utility.js.map
